<template>
    <b-card class="single-lender-card">
        <b-row>
            <b-col class="text-center">
                <home-company-logo
                    v-if="isLoanOfficerFinance && loanOfficerOrganizationLogo"
                    :logo-src="loanOfficerOrganizationLogo"
                />
                <b-img
                    v-else
                    class="card-img"
                    :src="icon"
                />
            </b-col>
        </b-row>

        <b-row class="my-4">
            <b-col class="text-center">
                <p class="lender-name mb-0">
                    {{ financeAppResource.singleLenderName }}
                </p>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="text-center">
                <b-link
                    class="lender-url"
                    :href="financeAppResource.singleLenderUrl"
                    target="_blank"
                >
                    Get Started
                </b-link>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    import './SingleLenderCard.scss';
    import './SingleLenderCard.mobile.scss';
    import LandingPageFinanceSectionAppResource
        from '@milestoneslabs/milestones-core-js/src/AppResources/LandingPageFinanceSectionAppResource';
    import {FINANCE_IMAGES} from '../../../../helpers/images';
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import HomeCompanyLogo from "../../Home/HomeCompanyLogo/HomeCompanyLogo";

    export default {
        name: 'SingleLenderCard',
        components: {HomeCompanyLogo},
        data() {
            return {
                icon: FINANCE_IMAGES.SINGLE_LENDER_CARD_IMAGE,
            };
        },

        props: {
            financeAppResource: {
                type: LandingPageFinanceSectionAppResource,
                required: true,
            },
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
        },

        computed: {
            isLoanOfficerFinance() {
                return (this.landingPage.home || {}).loanOfficer;
            },

            loanOfficerOrganizationLogo() {
                return (((this.landingPage.home || {}).loanOfficer || {}).organizationLogo || {}).publicStorageUrl;
            },
        },
    };
</script>
